// extracted by mini-css-extract-plugin
export var addressCarousel = "carousel-module--address-carousel--57e17";
export var addressCarouselItem = "carousel-module--address-carousel-item--8a79e";
export var addressImg = "carousel-module--address-img--29df1";
export var addressImgSolo = "carousel-module--address-img-solo--85863";
export var carouselLightBoxOpener = "carousel-module--carousel-light-box-opener--0ddfe";